import { render, staticRenderFns } from "./CGW.vue?vue&type=template&id=22d1c816&scoped=true"
import script from "./CGW.vue?vue&type=script&lang=js"
export * from "./CGW.vue?vue&type=script&lang=js"
import style0 from "./CGW.vue?vue&type=style&index=0&id=22d1c816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d1c816",
  null
  
)

export default component.exports